const menu = [
  {
    // 옵션 목록
    id: "m1",
    name: "전체",
    color: "#A1A1B1",
    border: "#E5E5E5",
  },
  {
    id: "m2",
    name: "기사",
    color: "#A1A1B1",
    border: "#E5E5E5",
  },
  {
    id: "m3",
    name: "칼럼",
    color: "#A1A1B1",
    border: "#E5E5E5",
  },
  {
    id: "m4",
    name: "내가 쓴글",
    color: "#A1A1B1",
    border: "#E5E5E5",
  },
];

export default menu;
